export const sortKeys = obj => {
  return Object.keys(obj).sort((a, b) => (a > b ? 1 : -1))
}



// WEBPACK FOOTER //
// ./src/lib/helpers/sortKeys.js